import { Add } from "@mui/icons-material";
// import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  // Button,
  Chip,
  Grid,
  Slide,
  // Stack,
  useTheme,
} from "@mui/material";
import {
  useGetAccountByNameQuery,
  useGetPartnersQuery,
} from "api/api-accounts";
import { useFetchStatusMasterQuery } from "api/api-category-status";
import {
  ACCOUNTS,
  BUYER,
  INCOMLEND_INTERNAL_LINK,
  SELLER,
  SUPPLIER,
} from "codes";
import AuditTrailViewer from "components/Common/AuditTrail";
import Layout from "components/Common/Layout";
import StatusProgressBar from "components/Common/ProgressBar";
import SkeletonLoad from "components/Common/SkeletonLoad";
import AccountSectionTabs from "components/Company/Account/AccountSectionTabs";
import { Form, Formik } from "formik";
import { useParams } from "react-router-dom";
import { useState } from "react";
import CreateLeadPartner from "components/Company/Lead/CreateLeadPartner";
import AddAccountUser from "components/Onboard/User/AddAccountUser";
import history from "helpers/history";

const Account = () => {
  const { id } = useParams();
  const theme = useTheme();
  const {
    data: account,
    isFetching: isFetchingLead,
    isLoading: isLoadingLead,
    refetch: refetchLead,
  } = useGetAccountByNameQuery(id ?? "", { skip: !id });
  const getStatus = account?.status;
  const { data: statusMaster } = useFetchStatusMasterQuery();
  const currentCategory = statusMaster?.ACCOUNT?.map((item) => item.category);

  const profile = account?.profile ?? "";

  const partnerType = profile === SELLER ? BUYER?.toLowerCase() : SELLER;
  const partnerName = partnerType === SELLER ? SUPPLIER : BUYER;

  const getLabel = (profile: string) =>
    profile !== ""
      ? profile?.toLowerCase() === SELLER
        ? SUPPLIER
        : BUYER
      : "No Profile Set";

  const {
    data: partners,
    isFetching,
    isUninitialized: isPartnersUninitialized,
    isLoading,
    refetch: refetchPartners,
  } = useGetPartnersQuery(account?.id ?? "", {
    skip: !Boolean(account?.id),
  });
  const syncAction = () => {
    refetchLead();
    refetchPartners();
  };

  const [addTradePartnerState, setAddTradePartnerState] = useState(false);
  const [addUserState, setAddUserState] = useState(false);
  const isCreatorMode = (addTradePartnerState || addUserState) && Boolean(account);
  const VIEW_MODE = !(addTradePartnerState || addUserState);

  return (
    <Slide in direction="left">
      <Box sx={{ display: "flex" }} flexGrow={1}>
        <Layout
          title={
            addTradePartnerState
              ? `Add a partner for ${account?.name}`
              : account?.name ?? ""
          }
          backArrow={VIEW_MODE}
          backLink={`${INCOMLEND_INTERNAL_LINK}${ACCOUNTS}`}
          subtitle=""
          textHeadingOptions={{
            fontWeight: "bolder",
            level: 2,
            sx: {
              fontSize: "1.2em",
              [theme.breakpoints.down("md")]: {
                fontSize: "1.5em",
              },
            },
          }}
          headerConfig={{
            left: addTradePartnerState || addUserState ? 9 : 7.5,
            mid: 1.5,
            right: addTradePartnerState || addUserState ? 1.5 : 3,
            syncAction,
            endComponent: (
              <Grid item>
                <Chip
                  label={getLabel(profile)}
                  sx={{ height: "3em" }}
                  variant="outlined"
                />
              </Grid>
            ),
            xs: {
              left: 12,
              mid: 0,
              right: 12,
            },
            alignItems: "center",
          }}
          primary={
            !addUserState
              ? {
                  children: addTradePartnerState ? "Cancel" : "Partner",
                  startIcon: addTradePartnerState ? undefined : <Add />,
                  fullWidth: true,
                  isCancel: addTradePartnerState,
                  onClick: () => setAddTradePartnerState((prev) => !prev),
                }
              : undefined
          }
          secondary={
            !addTradePartnerState
              ? {
                  children: addUserState ? "Cancel" : "User",
                  startIcon: addUserState ? undefined : <Add />,
                  fullWidth: true,
                  color: addUserState ? "error" : "primary",
                  onClick: () => setAddUserState((prev) => !prev),
                }
              : undefined
          }
          mode="default"
        >
          {VIEW_MODE && (
            <Grid container spacing={{ xs: 3, lg: 1 }}>
              <Grid item xs={12} my={1}>
                <StatusProgressBar
                  category={currentCategory?.[0]}
                  status={getStatus}
                />
              </Grid>
              {isFetchingLead && <SkeletonLoad bars={5} />}
              {!isFetchingLead && account && (
                <Formik
                  enableReinitialize
                  initialValues={{
                    any_credit_note: false,
                    any_delays_of_payment_with_buyer: false,
                    ...account,
                    partners,
                    syncAction,
                  }}
                  onSubmit={() => {}}
                >
                  <Form>
                    <AccountSectionTabs />
                  </Form>
                </Formik>
              )}
              <Grid item xs={12}>
                <Box sx={{ mt: 3 }}>
                  {account && (
                    <AuditTrailViewer recordIdFilter={account.id} />
                  )}
                </Box>
              </Grid>
            </Grid>
          )}

          {addTradePartnerState && (
            <>
              {isFetchingLead && <SkeletonLoad bars={5} />}
              {!isFetchingLead && account && (
                <CreateLeadPartner
                  onEnd={() => {
                    setAddTradePartnerState(false);
                    syncAction();
                  }}
                  partnerType={partnerType}
                  lead_id={account?.id}
                  lead_internal_name={account.internal_name}
                />
              )}
            </>
          )}

          {addUserState && (
            <>
              {isFetchingLead && <SkeletonLoad bars={5} />}
              {!isFetchingLead && account && (
                <AddAccountUser
                  account_id={account?.id}
                  callBack={async () => {
                      setAddUserState(false);
                      await refetchLead().unwrap();
                      history.push(`${INCOMLEND_INTERNAL_LINK}/accounts/${account?.internal_name}`);
                    }
                  }
                />
              )}
            </>
          )}
        </Layout>
      </Box>
    </Slide>
  );
};
export default Account;
